import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapMutations, mapState } from 'vuex';
import useIdToFindCategory from '../utils/use-id-to-find-category';
import { previewMixin } from '../mixin/preview.js';
import { isElement } from '../utils';
import { categoryConfig } from '@/store/creative/common/category';

export default {
  mixins: [previewMixin],

  data: function data() {
    return {};
  },


  computed: _extends({}, mapState({
    category: function category(state) {
      return (state.creative.template.outline || {}).category || [];
    },
    groupsConfig: function groupsConfig(state) {
      return state.creative.template.groupsConfig || [];
    },
    activeCategoryId: function activeCategoryId(state) {
      return state.creative.template.activeCategoryId;
    },
    currentTab: function currentTab(state) {
      return state.creative.template.currentTab;
    },
    previewGroupConfig: function previewGroupConfig(state) {
      return state.creative.template.previewGroupConfig;
    }
  }), {
    options: function options() {
      return [{
        label: this.$t('playTurbo.custom.previewer.selectVersion'),
        options: this.groupsConfig
      }];
    },


    currentGroup: {
      get: function get() {
        return this.$store.state.creative.template.previewGroup;
      },
      set: function set(val) {
        this.select(val);
      }
    }
  }),

  methods: _extends({}, mapMutations({
    updateActiveCategoryId: 'creative/template/updateActiveCategoryId',
    updateActiveCategoryNode: 'creative/template/updateActiveCategoryNode',
    updatePreviewGroupConfig: 'creative/template/updatePreviewGroupConfig'
  }), {
    select: function select(group) {
      this.updatePreviewGroupConfig(group);

      // 如果在元素分类下，切换到多组合元素分类
      if (isElement(this.currentTab)) {
        var id = categoryConfig.multiCustomCategory.id;
        var categoryNode = useIdToFindCategory({ category: this.category, categoryId: id });
        // 多组合元素分类有子分类时才跳转
        if (_.isArray(categoryNode.sub_category) && categoryNode.sub_category.length > 0) {
          this.updateActiveCategoryId(id);
          this.updateActiveCategoryNode(categoryNode);
        }
      }

      this.preview();
    }
  })
};